<template>
  <b-row>
    <b-col md="12">
      <!-- Alert: No item found -->
      <b-alert
        variant="danger"
        :show="errorMessage !== ''"
      >
        <h4 class="alert-heading">
          {{ errorMessage }}
        </h4>
      </b-alert>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class=""
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <b-row>
            <div class="col-12 justify-content-between d-flex">
              <label
                for=""
                class="d-block font-weight-bolder"
              >Danh sách thiết bị</label>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-info"
                class="mb-2"
                type="button"
                @click="showDevice()"
              >
                <feather-icon icon="PlusCircleIcon" /> Thêm thiết bị
              </b-button>
            </div>
            <div class="col-4 mb-1">
              <b-input-group>
                <b-form-input
                  v-model="localSearch"
                  class="d-inline-block"
                  placeholder="Nhập tên thiết bị"
                  @keydown.enter.prevent="doSearch"
                />
                <b-input-group-append>
                  <span
                    class="btn btn-primary"
                    @click="doSearch"
                  >
                    <feather-icon icon="SearchIcon" />
                  </span>
                </b-input-group-append>
              </b-input-group>
            </div>
            <table class="table table-rep">
              <thead>
                <tr>
                  <th>Tên thiết bị</th>
                  <th>Series</th>
                  <th class="text-center">
                    Hành động
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.device_id"
                >
                  <td>{{ item.device_name }}</td>
                  <td>{{ convertArrayToString(item.seriIds) }}</td>
                  <td class="text-center">
                    <b-button
                      class="btn btn-icon mr-1 btn-sm btn-warning"
                      @click="editDevice(item, itemData.id)"
                    >
                      <span class="text-nowrap">
                        <feather-icon icon="EditIcon" />
                      </span>
                    </b-button>
                    <b-button
                      class="btn btn-icon btn-sm btn-danger"
                      @click="handlRemoveDevice(item)"
                    >
                      <span class="text-nowrap">
                        <feather-icon icon="Trash2Icon" />
                      </span>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-row>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              class="mr-2"
              type="button"
              @click="closeModalShowDevice()"
            >
              <span>Đóng</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="loading"
            >
              <span v-if="mdata.id > 0">{{ $t('Update') }}</span>
              <span v-else>{{ $t('Save') }}</span>
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-col>
    <b-modal
      id="formSearchDevice"
      body-class=" mb-2"
      size="sm"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      title="Thiết bị"
    >
      <form-search-device
        :devices="items"
        @updateDevice="handleDevice"
        @resetData="handleDialog"
      />
    </b-modal>
    <b-modal
      id="formEditDevice"
      body-class=" mb-2"
      size="lg"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      title="Thay đổi series"
    >
      <form-edit-device-series
        :device="itemDevice"
        :vehicle-book-id="vehicleBookId"
        @resetData="handleDialogEditDevice"
        @updateDevice="handleDevice"
      />
    </b-modal>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BAlert,
  BOverlay,
  BForm,
  BFormGroup,
  BButton,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormTextarea,
  BCardText,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
import store from '@/store';
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNumDot, max, integer,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation';
import Ripple from 'vue-ripple-directive';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import vSelect from 'vue-select';
import moment from 'moment';

import { tStr } from 'validation_t/src';
import FormSearchDevice from './FormSearchDevice.vue';
import FormEditDeviceSeries from './FormEditDeviceSeries.vue';

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BCardText,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    flatPickr,
    vSelect,
    moment,
    BInputGroup,
    BInputGroupAppend,
    FormSearchDevice,
    FormEditDeviceSeries,
  },
  directives: {
    Ripple,
  },
  props: {
    mdata: Object,
  },
  data() {
    return {
      required,
      alphaNumDot,
      max,
      dataManufacture: [],
    };
  },
  computed: {},
  methods: {
    showDevice() {
      this.$bvModal.show('formSearchDevice');
    },
    handleDevice(data) {
      let indexOldData = 0;
      if (this.items !== null) {
        if (this.dataDeviceOriginal !== null) {
          indexOldData = this.items.findIndex(
            (t) => t.device_id === data.device_id,
          );
          if (+indexOldData > -1 && data.seriIds.length > 0) {
            this.dataDeviceOriginal.splice(indexOldData, 1, data);
          } else if (data.seriIds.length > 0) {
            this.dataDeviceOriginal.push(data);
          }
        } else {
          this.dataDeviceOriginal.push(data);
        }
      } else {
        this.dataDeviceOriginal.push(data);
      }
      this.items = this.dataDeviceOriginal;
      this.$bvModal.hide('formSearchDevice');
      this.$bvModal.hide('formEditDevice');
    },
    convertArrayToString(items) {
      return items.map((o) => o.name).join(',');
    },
    handlRemoveDevice(data) {
      const item = this.dataDeviceOriginal.filter(t => t.device_id !== data.device_id);
      this.items = item;
      this.itemRemoves.push(data);
      this.dataDeviceOriginal = item
    },
    editDevice(item, vehicleBookId) {
      this.itemDevice = item
      this.vehicleBookId = vehicleBookId
      this.$bvModal.show('formEditDevice');
    },
    handleDialog() {
      this.$bvModal.hide('formSearchDevice');
    },
    handleDialogEditDevice() {
      this.$bvModal.hide('formEditDevice');
    },
    doSearch() {
      if (this.localSearch !== '') {
        const dataSearch = this.dataDeviceOriginal.filter((o) => {
          const fName = o.device_name;
          const byQuery = this.localSearch
            ? String(tStr.removeAscent(fName))
              .toLowerCase()
              .replaceAll(' ', '')
              .includes(
                String(tStr.removeAscent(this.localSearch))
                  .toLowerCase()
                  .replaceAll(' ', ''),
              )
            : true;
          return byQuery;
        });
        this.items = dataSearch;
      } else {
        this.items = this.dataDeviceOriginal;
      }
    },
    closeModalShowDevice() {
      this.$bvModal.hide('showAddDevice');
    },
  },

  setup(props, { emit }) {
    const { route, router } = useRouter();
    const id = ref(
      route.value.params.id !== undefined ? route.value.params.id : 0,
    );
    const errorMessage = ref('');
    const loading = ref(false);
    const dataSeries = ref([]);
    const dataVehicle = ref([]);
    const dataUser = ref([]);
    const dataForms = ref([]);
    const items = ref([]);
    const itemDevice = ref([]);
    const itemRemoves = ref([])
    const dataDeviceOriginal = ref([]);
    const localSearch = ref('');
    const vehicleBookId = ref('');
    const typeOptions = [
      { name: 'Không lặp', id: 1 },
      { name: 'Lặp hàng ngày', id: 2 },
    ];
    const defaultItemData = {
      content: '',
      description: '',
      mobile_vehicle_id: null,
      plan_date: '',
      start_date: '',
      end_date: '',
      manager_ids: [],
    };
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)));
    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData));
    };
    const formatDateHour = (val) => moment(String(val)).format('DD-MM-YYYY HH:mm');

    if (props.mdata) {
      itemData.value = props.mdata;
      dataForms.value = itemData.value.data_fields;
      items.value = itemData.value.data_devices ? itemData.value.data_devices : []
      dataDeviceOriginal.value = itemData.value.data_devices ? itemData.value.data_devices : []
      // store
      //   .dispatch('mobileVehicle/fetchOneMobileVehicleBook', {
      //     id: props.mdata.id,
      //   })
      //   .then((response) => {
      //     const result = response.data;
      //     if (result.code === 200) {
      //       itemData.value = result.data;
      //       dataForms.value = itemData.value.data_fields;
      //       items.value = itemData.value.data_devices ? itemData.value.data_devices : []
      //       dataDeviceOriginal.value = itemData.value.data_devices ? itemData.value.data_devices : []
      //     }
      //   })
      //   .catch((error) => {
      //     console.log('error', error);
      //   });
    }

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetItemData);

    const fetchManager = () => {
      store
        .dispatch('users/fetchUsers', {
          isPaginate: '0',
        })
        .then((response) => {
          if (response.data.code === 200) {
            dataUser.value = response.data.data;
          }
        });
    };
    fetchManager();

    const onSubmit = () => {
      errorMessage.value = '';

      if (itemData.value.id != null) {
        loading.value = true;
        itemData.value.items = dataDeviceOriginal.value;
        itemData.value.dataDeviceOriginal = dataDeviceOriginal.value; // gốc
        store
          .dispatch('mobileVehicle/addMoreDevice', {
            data: itemData.value,
            id: itemData.value.id,
          })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.code === 200) {
                showToast(response.data.message, { variant: 'success' });
                resetForm();

                loading.value = false;
                emit('updateData');
              } else {
                showToast(response.data.message);
                errorMessage.value = response.data.message;
              }
            } else {
              loading.value = false;
            }
          });
      }
    };

    const today = new Date();
    const hour = today.getHours();
    const configDate = ref({
      dateFormat: 'd-m-Y H:i',
      enableTime: true,
      locale: Vietnamese, // locale for this instance only
      defaultHour: hour,
      time_24hr: true,
      theme: 'dark',
    });
    return {
      id,
      errorMessage,
      itemData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      configDate,
      dataSeries,
      dataVehicle,
      typeOptions,
      formatDateHour,
      dataUser,
      dataForms,
      items,
      dataDeviceOriginal,
      localSearch,
      itemDevice,
      vehicleBookId,
      itemRemoves,
      loading,
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
